import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { DASHBOARD_SHOW } from 'src/constants/EndpointUrls';
import { USER_ACCOUNT_PASSWORD_FORM } from 'src/constants/FormNames';
import { Section, TextField } from 'src/jbc-front/components/Form';
import Button from 'jbc-front/components/Button';
import { FormSubmitBtn } from 'src/buttons';
import { editPassword } from 'src/reducers/users/currentUser';
import { redirectTo } from 'src/utils/Http';
import { useTranslation } from 'react-i18next';

const RawSettingPasswordForm = ({ handleSubmit, submit, submitting, pristine }) => {
  const { t } = useTranslation();
  return (
    <form onSubmit={handleSubmit}>
      <Section>
        <TextField label={t('features.Users.components.SettingPasswordForm.old_password')} name="oldPassword" type="password" required />
        <TextField label={t('features.Users.components.SettingPasswordForm.new_password')} name="password" type="password" required />
        <TextField label={t('features.Users.components.SettingPasswordForm.new_password_confirm')} name="passwordConfirmation" type="password" required />
      </Section>
      <div className="u-ta-c u-mt30">
        <Button onClick={() => redirectTo(DASHBOARD_SHOW)} className="u-mr20">
          {t('features.Users.components.SettingPasswordForm.cancel')}
        </Button>
        <FormSubmitBtn {...{ submit, submitting, pristine }} />
      </div>
    </form>
  );
};

const SettingPasswordForm = reduxForm({
  form: USER_ACCOUNT_PASSWORD_FORM
})(RawSettingPasswordForm);

export default connect(null, dispatch => ({
  onSubmit: data => dispatch(editPassword(data))
}))(SettingPasswordForm);
